import React from 'react';
import { ListGroup, ListGroupItem, Collapse } from 'react-bootstrap';
import FeatureList from './FeatureList';
import FeatureForm from './FeatureForm';

class FeatureClassList extends React.Component {

   constructor(props) {
      super(props);
      this.state = {
         openIndex: -1
      };
   }

   changeOpenIndex = (openIndex) => {
      this.setState({
         openIndex: (openIndex === this.state.openIndex) ? -1 : openIndex
      });
   };


   render() {
      const { featureClasses } = this.props;
      const { openIndex } = this.state;
      return (
         <ListGroup>
            {featureClasses.map((featureClass, featureClassIndex) => (
               <ListGroupItem key={featureClass.id} >
                  <span onClick={() => this.changeOpenIndex(featureClassIndex)} >{featureClass.name}</span>
                  <Collapse in={openIndex === featureClassIndex} >
                     <div>
                        {featureClass.features
                        && <FeatureList features={featureClass.features} />
                        }
                        <FeatureForm featureClassId={featureClass.id} />
                     </div>
                  </Collapse>
               </ListGroupItem>
            ))}
         </ListGroup>
      );
   }
}
FeatureClassList.propTypes = {
   featureClasses: React.PropTypes.array
};
export default FeatureClassList;



/** WEBPACK FOOTER **
 ** ./src/components/ItemManagement/FeatureClass/FeatureClassList.js
 **/